import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const MarketingSubscriptionRoutes = defineRoute({
    record: {
        route: {
            path: "/marketing-subscription",
            component: () => loadView(import("./MarketingSubscriptionTable.vue")),
        },
    },
});
